<!-- src/components/Notification.vue -->
<template>
  <div>
   mensaje
  </div>
</template>

 